export default "__VITE_ASSET__BlIR6lWY__"